import React, { useState, useEffect } from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { ReactComponent as ArrowLeftSquare } from "bootstrap-icons/icons/arrow-left-square-fill.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
import ApiServices from "../../api/ApiServices";
import { toast } from "react-toastify";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { handleError } from "../../components/utils/AuthenticationCheck";
// import AxiosApiCall from "../../../api/AxiosApiCall";
import AxiosApiCall from "../../api/AxiosApiCall";

const UpdateReturnOrder = () => {
  const [name, setName] = useState("");
  const [status, setStatus] = useState("");
  const [reason, setRejectReason] = useState(null);
  const [cancel_request_id, setRequestId] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const returnOrders = location.state?.returnOrders;

  useEffect(() => {
    if (returnOrders) {
      // console.log("rejected orders", returnOrders);
      setName(returnOrders.order.order_items.map(item => item.product?.name).filter(name => name).join(", ") || "");
      setRequestId(returnOrders.id || "");
    }
  }, [returnOrders]);

  const validateForm = () => {
    // if (!name || !status) {
    //   toast.error("Approval is required.");
    //   return false;
    // }
    if (status === "rejected" && !reason) {
      toast.error("Reason for disapproval is required.");
      return false;
    }

    return true;
  };

  // axios api encryption call
  const axios = AxiosApiCall();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    const formData = {
      cancel_request_id,
      status,
      reason: reason || "",
    };
    // console.log("data for update return item", formData);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) throw new Error("No access token found.");

      const response = await axios.put(
        ApiServices.UpdateCustomerReturnOrder,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
          withCredentials: true,
        }
      );

      const { status, message } = response.data;
      if (status === 200) {
        toast.success(message, { toastId: "profit-stock-approval-added-success" });
        setTimeout(() => {
          navigate("/admin/customer/order/return");
        }, 500);
        setLoading(false); // stop loading this is for the submit button color loading
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className="body-font">
            <div className="container px-5 pb-2 mx-auto">
              <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
                <nav className="bg-gray-200 py-0 px-4 rounded-lg">
                  <ol className="list-none p-0 inline-flex mb-2">
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                        Rejected Item
                      </p>
                      <ChevronRightIcon />
                    </li>
                    <li className="flex items-center">
                      <p className="text-blue-500 hover:text-blue-600 text-orange1 pr-2">
                        Update
                      </p>
                    </li>
                  </ol>
                </nav>
              </section>

              <div className="lg:w-full md:w-full bg-white rounded-lg p-8 flex flex-col md:ml-auto w-full mt-10 md:mt-0 relative z-10 shadow-md bg-dGrey3">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                  {/* Left Column: Ordered Items */}
                  <div className="w-full">
                    <label
                      htmlFor="name"
                      className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                    >
                      Ordered Items
                    </label>
                    <ul className="list-decimal pl-6">
                      {name ? (
                        <li>{name}</li>
                      ) : (
                        <li>No items available</li>
                      )}
                    </ul>
                  </div>

                  {/* Right Column: Form */}
                  <div className="w-full">
                    <form onSubmit={handleSubmit}>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                        <input type="hidden" name="cancel_request_id" value={cancel_request_id} />
                        <div className="w-full col-span-2">
                          <label
                            htmlFor="status"
                            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                          >
                            <span className="text-darkGreen3">Approval</span>/
                            <span className="text-dash3">Disapproval</span>
                          </label>
                          <select
                            id="approval"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                            className="bg-gray-50 border border-dGrey1 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
                          >
                            <option value="" disabled>
                              Select
                            </option>
                            <option value="approved">Approve</option>
                            <option value="rejected">Disapprove</option>
                          </select>
                        </div>

                        {status === "rejected" && (
                          <div className="w-full col-span-2">
                            <label
                              htmlFor="approve_type"
                              className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                            >
                              Reason for Disapproval
                            </label>
                            <textarea
                              id="reason"
                              name="reason"
                              value={reason || ""}
                              onChange={(e) => setRejectReason(e.target.value)}
                              className="border border-grey3 p-2 rounded-md w-full"
                              rows="4"
                              placeholder="Enter your reason"
                            />
                          </div>
                        )}
                      </div>

                      {/* Buttons */}
                      <div className="flex flex-col gap-4 md:flex-row md:gap-4 md:justify-end mt-4">
                        <Link
                          to="/admin/customer/order/return"
                          className="text-dGrey3 py-3 bg-black2 hover:bg-blue-800 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 text-center flex items-center"
                        >
                          <List className="mr-2" />
                          Back To List
                        </Link>
                        <button
                          type="submit"
                          className={`text-dGrey3 capitalize border-0 py-2 px-6 focus:outline-none rounded font-medium
                          ${status === "2" ? "bg-dash3 hover:bg-red-700" : "bg-darkGreen3 hover:bg-indigo-600"}
                          ${loading ? "opacity-50 cursor-not-allowed" : ""}`}
                          disabled={loading}
                        >
                          {loading
                            ? "Loading..."
                            : status === "rejected"
                              ? "Disapprove"
                              : "Approve"}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section >
        </div >
      </MainLayouts >
    </div >
  );
};

export default UpdateReturnOrder;
